"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.5.2'] && _();
}
catch (e) { }
